import httpClient from './httpClient';

const API_BASE = '/api/leftovers';

const leftoverService = {
  async findAvailable(params) {
    const response = await httpClient.get(`${API_BASE}/available`, { params });
    return response.data;
  },

  async getById(id) {
    const response = await httpClient.get(`${API_BASE}/${id}`);
    return response.data;
  },

  async getByParentId(parentId) {
    const response = await httpClient.get(`${API_BASE}/by-parent/${parentId}`);
    return response.data;
  },

  async createConsumption(data) {
    const response = await httpClient.post(`${API_BASE}/consume`, data);
    return response.data;
  },

  async approveConsumption(consumptionId) {
    const response = await httpClient.post(`${API_BASE}/consume/${consumptionId}/approve`);
    return response.data;
  },

  async rejectConsumption(consumptionId, reason) {
    const response = await httpClient.post(`${API_BASE}/consume/${consumptionId}/reject`, { reason });
    return response.data;
  },

  async getConsumptionRequests(params = {}) {
    const response = await httpClient.get(`${API_BASE}/consumptions`, { params });
    return response.data;
  }
};

export default leftoverService;
